import React from 'react';
import { useNavigate as useNavigate_, useSearchParams } from 'react-router-dom';
import { getSavedListSearch } from 'helpers/listSearchStorage';

export function useNavigate() {
  let navigate = useNavigate_();
  let [searchParams] = useSearchParams();
  return React.useCallback(
    (to, ...reset) => {
      let search = searchParams.toString();
      // Current page has no params (e.g. edit page): restore the filters
      // the target page had last time
      if (!search && typeof to === 'string' && !to.includes('?')) {
        search = getSavedListSearch(to);
      }
      return navigate(to + `?${search}`, ...reset);
    },
    [navigate, searchParams]
  );
}
